<template>
  <div class="root-container" v-if="baseInfoConf">
    <div class="top-container">
      <span class="title">{{ baseInfoConf.title }}</span>
      <div class="date-extra">
        <span class="date">{{ baseInfoConf.gmtCreate }}</span>
        <span class="extra" @click="onExtraClick" v-if="baseInfoConf.fileUrl"
          >查看附件</span
        >
      </div>
    </div>
    <div v-html="baseInfoConf.content"></div>
    <van-popup v-model="showPdf" style="width: 85%; height: 85%">
      <iframe :src="baseInfoConf.fileUrl" style="width: 100%;height: 100%;"></iframe>
    </van-popup>
    <div class="zan-container" v-if="carsId" @click="onZanClick">
      <van-image
        width="40"
        height="40"
        :src="'1' == isOkCar ? iconZanSle : iconZanNor"
      ></van-image>
      <span class="count">{{ isOkCount }}</span>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import md5 from "js-md5";
import util from "@/utils/util";
import { Toast } from "vant";
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      //https://haier-ossocr.oss-cn-beijing.aliyuncs.com/images/2023/08/11/16917349400011661100.pdf
      //https://haier-ossocr.oss-cn-beijing.aliyuncs.com/images/2023/08/11/16917340348823602100.docx
      //https://haier-ossocr.oss-cn-beijing.aliyuncs.com/images/2023/08/11/16917356380128065100.pptx
      //d8b18695cc15455c96084ee370528422
      baseInfoConf: null,
      isOkCount: 0, //文章总点赞人数
      isOkCar: "", //当前司机是否点赞，1：点赞过，0：未点赞
      baseInfoConfId: "", //url参数 详情id
      carsId: "", //url参数 司机id
      env: "", //url参数 环境
      showPdf: false,
      iconZanSle: require("/static/img/icon_zan_sle.png"),
      iconZanNor: require("/static/img/icon_zan_nor.png"),
    };
  },
  created() {
    this.baseInfoConfId = util.getUrlKey("id");
    this.carsId = util.getUrlKey("carsId");
    this.env = util.getUrlKey("env") || "test";
    this.initData();
  },
  mounted() {},
  methods: {
    initData() {
      const baseUrl =
        "test" == this.env
          ? "http://123.56.28.7:9008/sc/driver/ext/api/"
          : "https://ext.rrskx.com/sc/driver/ext/api/";

      let url = baseUrl + "carsInfo/queryBaseInfoConf";
      const time = new Date().getTime();
      const sign = this.getSign(time);
      axios
        .post(
          url,
          {
            baseInfoConfId: this.baseInfoConfId,
            carsId: this.carsId,
            time: time,
            sign: sign,
          },
          {
            headers: { "content-type": "application/json" },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.status == 200 && res.data && res.data.code == "200") {
            this.isOkCount = res.data.data.isOkCount;
            this.isOkCar = res.data.data.isOkCar;
            this.baseInfoConf = res.data.data.baseInfoConf;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getSign(time) {
      const code = this.baseInfoConfId + time + "KX_EXT^&#@cArS!";
      const sign = md5(code);
      return sign.toUpperCase();
    },
    onExtraClick() {
      let fileUrl = this.baseInfoConf.fileUrl;
      if (fileUrl.indexOf("pdf") !== -1) {
        this.showPdf = true;
      } else if (
        fileUrl.indexOf("doc") !== -1 ||
        fileUrl.indexOf("docx") !== -1
      ) {
        this.view(fileUrl);
      } else if (
        fileUrl.indexOf("xsl") !== -1 ||
        fileUrl.indexOf("xslx") !== -1 ||
        fileUrl.indexOf("xls") !== -1
      ) {
      } else if (
        fileUrl.indexOf("jpg") !== -1 ||
        fileUrl.indexOf("png") !== -1 ||
        fileUrl.indexOf("jpeg") !== -1
      ) {
      } else if (
        fileUrl.indexOf("pptx") !== -1 ||
        fileUrl.indexOf("ppt") !== -1
      ) {
        this.view(fileUrl);
      }
    },
    onZanClick() {
      const baseUrl =
        "test" == this.env
          ? "http://123.56.28.7:9008/sc/driver/ext/api/"
          : "https://ext.rrskx.com/sc/driver/ext/api/";

      let url = baseUrl + "carsInfo/baseInfoConfIsOk";
      const time = new Date().getTime();
      const sign = this.getSign(time);
      axios
        .post(
          url,
          {
            baseInfoConfId: this.baseInfoConfId,
            carsId: this.carsId,
            isOk: "0" == this.isOkCar ? "1" : "0", //点赞操作：，1点赞，0取消点赞
            time: time,
            sign: sign,
          },
          {
            headers: { "content-type": "application/json" },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.status == 200 && res.data && res.data.code == "200") {
            Toast("操作成功");
          }
          this.initData();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    view(url) {
      const src =
        "http://view.officeapps.live.com/op/view.aspx?src=" +
        encodeURIComponent(url);
      window.location.href = src;
    },
  },
};
</script>

<style lang="scss" scoped>
.root-container {
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 20px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

.top-container {
  display: flex;
  flex-direction: column;

  .title {
    font-size: 17px;
    color: black;
  }

  .date-extra {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .date {
      font-size: 15px;
      color: #999999;
    }

    .extra {
      color: #4a66f8;
      font-size: 15px;
      text-decoration: underline;
    }
  }
}

.zan-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .count {
    color: #4a66f8;
    font-size: 15px;
  }
}
</style>